import React from "react";

export default function ResultBox({ label, value, wide }) {
  return (
    <div
      className={`rounded-xl px-4 py-3 bg-neutral-900 ${wide ? "sm:col-span-2" : ""}`}
    >
      <div className="text-xs mb-1 text-neutral-400">{label}</div>
      <div className="text-base font-semibold text-neutral-200">
        {value}
      </div>
    </div>
  );
}
